import React from 'react';

const Toolbar = ({
  selectedId,
  items,
  onCreate,
  onEdit,
  onDelete,
  // dynamic actions: array of { key, label, icon, variant, onClick, show=true, disabled=false, requiresSelection }
  actions = null,
  // optional integrated search
  searchValue,
  onSearch,
  searchPlaceholder = 'Buscar...',
  searchWidth = '320px',
  // optional custom search controls (React node) - if provided, rendered instead of the simple search input
  searchControls = null,
  children,
}) => {
  const handleEdit = () => {
    if (!selectedId) return;
    if (onEdit) onEdit(selectedId);
  };

  const handleDelete = () => {
    if (!selectedId) return;
    if (onDelete) onDelete(selectedId);
  };

  // dynamic actions should provide their own handlers via `actions` prop
  // note: do not force button height here — keep Bootstrap defaults

  return (
    <div className="d-flex flex-column flex-md-row gap-2 mb-2 align-items-center justify-content-between flex-wrap">
      <div className="botao-grid-2col mb-0" style={{ flex: 1 }}>
        {(onCreate || onEdit || onDelete) && (
          <>
            {onCreate && <button className="btn btn-primary btn-sm botao-igual me-1" onClick={onCreate}><i className="bi bi-plus me-1"/>Novo</button>}
            {onEdit && <button className="btn btn-secondary btn-sm botao-igual me-1" onClick={handleEdit} disabled={!selectedId}><i className="bi bi-pencil me-1"/>Editar</button>}
            {onDelete && <button className="btn btn-danger btn-sm botao-igual me-1" onClick={handleDelete} disabled={!selectedId}><i className="bi bi-trash me-1"/>Excluir</button>}
          </>
        )}

        {/* dynamic actions (if provided) */}
        {Array.isArray(actions) ? (
          actions.map(a => {
            if (a.show === false) return null;
            const tokens = (a.variant || 'outline-secondary').split(/\s+/).filter(Boolean);
            const base = tokens[0];
            const variantClass = `btn-${base}`;
            const alreadyHasTextWhite = tokens.includes('text-white');
            const isOutline = base.startsWith('outline');
            const isLight = base === 'light';
            const needsWhite = !isOutline && !isLight && !alreadyHasTextWhite;
            const extraTextClass = needsWhite ? ' text-white' : (alreadyHasTextWhite ? ' text-white' : '');
            const cls = `btn ${variantClass}${extraTextClass} btn-sm me-1 botao-igual`;
            return (
              <button key={a.key || a.label} className={cls} onClick={() => a.onClick && a.onClick(selectedId)} disabled={!!a.disabled || (!selectedId && a.requiresSelection)}>
                {a.icon && <i className={`bi ${a.icon} me-1`} />} {a.label}
              </button>
            );
          })
        ) : null}

        {/* allow arbitrary children to be injected (extra controls) */}
        { (onCreate || onEdit || onDelete) && children ? <span className="toolbar-separator" /> : null }
        {children}
      </div>

      {/* search aligned to the right on same line for md+ screens; stacks on small screens */}
      {searchControls ? (
        <div className="ms-0 ms-md-3 ms-md-auto" style={{ minWidth: 0 }}>
          {searchControls}
        </div>
      ) : (typeof onSearch === 'function' ? (
        <div className="d-flex align-items-center ms-0 ms-md-3 ms-md-auto" style={{ minWidth: 0 }}>
          <div className="input-group input-group-sm" style={{ width: searchWidth }}>
            <span className="input-group-text">
              <i className="bi bi-funnel" aria-hidden="true" />
            </span>
            <input
              type="text"
              className="form-control filter-input-compact"
              placeholder={searchPlaceholder}
              value={searchValue ?? ''}
              onChange={e => onSearch(e.target.value)}
            />
          </div>
          {searchValue ? (
            <button type="button" className="btn btn-outline-secondary btn-sm ms-2 filter-clear-btn" onClick={() => onSearch('')} title="Limpar" aria-label="Limpar">
              <i className="bi bi-x-circle" aria-hidden="true"></i>
              <span className="visually-hidden">Limpar</span>
            </button>
          ) : null}
        </div>
      ) : null)}
    </div>
  );
};

export default Toolbar;
